import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {HeaderThemeEnum} from "../enum/theme.enum";

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  private headerTheme = new BehaviorSubject<HeaderThemeEnum>(HeaderThemeEnum.black);
  private headerTheme$ = this.headerTheme.asObservable();

  private menuToggleState = false;
  private menuToggleActive = new BehaviorSubject<boolean>(this.menuToggleState);
  private menuToggleActive$ = this.menuToggleActive.asObservable();


  constructor() {
  }

  setHeaderTheme(theme: HeaderThemeEnum) {
    this.headerTheme.next(theme);
  }

  getHeaderTheme(): Observable<HeaderThemeEnum> {
    return this.headerTheme$;
  }

  setMenuToggleActive() {
    this.menuToggleState = !this.menuToggleState;
    this.menuToggleActive.next(this.menuToggleState);
  }

  getMenuToggleActive(): Observable<boolean> {
    return this.menuToggleActive$;
  }

}
